function NoVideoContent(): JSX.Element {
  return (
    <div className="no-video">Video has not been found</div>
  );
}

export default NoVideoContent;
